import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { shouldSkipScrollToTop } from '@/utils/scrollToTop';

export default function ScrollToTop() {
  const { pathname } = useLocation();

  useEffect(() => {
    if (shouldSkipScrollToTop(pathname)) return;

    window.scrollTo({
      top: 0,
    });
  }, [pathname]);

  return null;
}
